const environment = {
    // apiUrl: 'https://localhost:44325/api/', // Local
    // apiReaderUrl: 'https://localhost:44373/api/', // Local
    apiReaderUrl: 'http://localhost/api/', // Local
    // apiUrl: 'http://172.17.100.2:8080/api/',  // OB prod
    // apiUrl: 'http://10.144.52.130:8080/api/',  // OB prod
    apiUrl: 'https://10.144.52.130:8088/api/',  // OB prod
    // apiUrl: 'https://fineday-vms-api.fs-omc.io/api/',  // OB prod
    apiUrlCarpark: 'https://10.144.66.34:444/api/',  // OB prod
}
export default environment